export default "__VITE_ASSET__CetfBUSC__"